"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickinessChartSettingsJSONModel = exports.ChartType = exports.isDefaultFilterFrequency = void 0;
const RetentionChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/model/RetentionChartSettingsJSONModel");
const lodash_1 = __importDefault(require("lodash"));
const defaultFilterFrequency = [1, 2, 3, 5];
const isDefaultFilterFrequency = (value) => lodash_1.default.isEqual(value, defaultFilterFrequency);
exports.isDefaultFilterFrequency = isDefaultFilterFrequency;
////////////////////////////////////////////////
// ChartType
////////////////////////////////////////////////
var ChartType;
(function (ChartType) {
    ChartType["classic"] = "classic";
    ChartType["overtime"] = "overtime";
})(ChartType = exports.ChartType || (exports.ChartType = {}));
class StickinessChartSettingsJSONModel {
    constructor(serializedState) {
        this.reset = () => {
            this.resetChartType();
            this.resetFilterCohortDays();
            this.resetFilterFrequency();
        };
        this.overwriteFromSerializedState = (serializedState) => {
            if (serializedState) {
                this.chartType = validateChartType(serializedState.chartType);
                this.filterCohortDays = (0, RetentionChartSettingsJSONModel_1.validateFilterCohortDays)(serializedState.filterCohortDays);
                this.filterFrequency = validateFilterFrequency(serializedState.filterFrequency);
            }
        };
        this.serialize = () => {
            return {
                chartType: this.chartType,
                filterCohortDays: this.filterCohortDays,
                filterFrequency: this.filterFrequency,
            };
        };
        ////////////////////////////////////////////////
        // ChartType
        ////////////////////////////////////////////////
        this.getChartType = () => this.chartType;
        this.setChartType = (value) => {
            this.chartType = validateChartType(value);
        };
        this.resetChartType = () => this.setChartType(undefined);
        ////////////////////////////////////////////////
        // FilterCohortDays
        ////////////////////////////////////////////////
        this.getFilterCohortDays = () => this.filterCohortDays;
        this.setFilterCohortDays = (value) => {
            this.filterCohortDays = (0, RetentionChartSettingsJSONModel_1.validateFilterCohortDays)(value);
        };
        this.resetFilterCohortDays = () => this.setFilterCohortDays(undefined);
        ////////////////////////////////////////////////
        // FilterFrequency
        ////////////////////////////////////////////////
        this.getFilterFrequency = () => this.filterFrequency;
        this.setFilterFrequency = (value) => {
            this.filterFrequency = validateFilterFrequency(value);
        };
        this.resetFilterFrequency = () => this.setFilterFrequency(undefined);
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.StickinessChartSettingsJSONModel = StickinessChartSettingsJSONModel;
////////////////////////////////////////////////
// ...
////////////////////////////////////////////////
StickinessChartSettingsJSONModel.getDefaultModel = () => {
    return new StickinessChartSettingsJSONModel().serialize();
};
const validateChartType = (value) => {
    if (typeof value === "string" && value in ChartType) {
        return value;
    }
    return ChartType.classic;
};
const validateFilterFrequency = (value) => {
    if (lodash_1.default.isArray(value)) {
        /**
         * we can use "_.compact" because overtime periods starts with 1
         */
        const result = lodash_1.default.compact(lodash_1.default.map(value, item => {
            const asNumber = lodash_1.default.toNumber(item);
            if (lodash_1.default.isFinite(asNumber)) {
                return asNumber;
            }
            return null;
        }));
        if (!lodash_1.default.isEmpty(result)) {
            return result;
        }
    }
    return lodash_1.default.cloneDeep(defaultFilterFrequency);
};
